import React, { useState, useEffect } from 'react'
import { Box, Button, Chip, CircularProgress, Dialog, Grid } from '@material-ui/core'
import styled from 'styled-components'
import { getDisabledDates, updateDisableDates } from '../../../modules/appointment'
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import DateFnsUtils from '@date-io/date-fns'
import format from 'date-fns/format'
import frLocale from 'date-fns/locale/es'
import { bool, func } from 'prop-types'
import useObjectState from '../../../hooks/useObjectState'
import { toString } from '../../../helpers/date'

class LocalizedUtils extends DateFnsUtils {
  getDatePickerHeaderText (date) {
    return format(date, 'd MMM yyyy', { locale: this.locale })
  }
}

const Body = styled.div`
  max-width: 500px;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 1px;
  min-height: 300px;
  width: 80vw;
  margin: auto;
`

const InputsCOntainer = styled.div`
  width: 100%;
  box-sizing: border-box;
  padding: 80px 20px;
  @media screen and (max-width:600px) {
    padding: 10px 10px;
  }
`

const ChipStyled = styled(Chip)`
  margin: .2em;
`

const DisabledDays = props => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useObjectState({ items: [] })
  const [isCalendarOpen, setCalendarOpen] = useState(false)

  const fetcher = async () => {
    setLoading(true)
    const disabledDate = await getDisabledDates()
    setData({ items: disabledDate })
    setLoading(false)
  }

  // fetch initial config
  useEffect(() => { fetcher() }, [])

  const handleAddDay = date => {
    setData({ items: data.items.concat(date) })
  }

  const handleDeleteDay = date => {
    const newdates = data.items.filter(item => item !== date)
    setData({ items: newdates })
  }

  const handleDisableDates = date => {
    // if (date.getDay() === 0 || date.getDay() === 6) return true
    return data.items.map(item => toString(item)).includes(toString(date))
  }

  const handleSave = async () => {
    setLoading(true)
    await updateDisableDates(data.items)
    await new Promise(resolve => setTimeout(resolve, 500))
    props.onClose()
    setLoading(false)
  }

  return (
    <Dialog open={props.open} onClose={props.onClose}>
      <MuiPickersUtilsProvider utils={LocalizedUtils} locale={frLocale}>
        <Body>

          {!loading && (
            <InputsCOntainer>
              <Box display='none'>
                <DatePicker disablePast open={isCalendarOpen} onClose={event => setCalendarOpen(false)} onChange={handleAddDay} shouldDisableDate={handleDisableDates} />
              </Box>
              <Box display='flex' justifyContent='center' flexWrap='wrap' mb={2} minHeight={150}>
                <Box width='100%' textAlign='center' fontSize='1.3em'>Fechas inhábiles</Box>
                {data.items.map((item) => (
                  <ChipStyled variant='outlined' key={item.getTime()} color='primary' label={toString(item)} onDelete={event => handleDeleteDay(item)} />
                ))}
                <ChipStyled label='+ Agregar' onClick={event => setCalendarOpen(true)} variant='outlined' color='primary' />
              </Box>
              <Grid container justify='center'>
                <Grid item xs={12} sm={8} container justify='center' spacing={2}>
                  <Grid item xs={12} />
                  <Grid item xs={6}>
                    <Button style={{ fontSize: '.8em', marginRight: '1em' }} fullWidth color='primary' variant='outlined' onClick={props.onClose}>Cancelar</Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button style={{ fontSize: '.8em' }} fullWidth color='primary' variant='contained' onClick={handleSave}>Guardar</Button>
                  </Grid>
                </Grid>
              </Grid>
            </InputsCOntainer>
          )}
          {loading && (
            <CircularProgress color='primary/' />
          )}

        </Body>
      </MuiPickersUtilsProvider>
    </Dialog>
  )
}

DisabledDays.propTypes = {
  open: bool,
  onClose: func
}

export default DisabledDays
